import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
  companyEntityList,
  companyEntityTransactions,
} from './companyEntityThunk';
import {
  CompanyEntityListResponse,
  CompanyEntityListSuccessPayload,
  CompanyEntityTransactions,
  CompanyEntityTransactionsResponse,
} from './types';

interface CompanyEntityState {
  entityTradesData: CompanyEntityTransactions[] | null;
  entityList: CompanyEntityListSuccessPayload[];
  entityListLoading: boolean;
}

const initialCompanyEntityState: CompanyEntityState = {
  entityTradesData: [],
  entityList: [],
  entityListLoading: false,
};

const CompanyEntitySlice = createSlice({
  name: 'companyEntity',
  initialState: initialCompanyEntityState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(companyEntityTransactions.pending, (state) => {
        state.entityTradesData = [];
      })
      .addCase(
        companyEntityTransactions.fulfilled,
        (state, action: PayloadAction<CompanyEntityTransactionsResponse>) => {
          state.entityTradesData = action.payload.data;
        },
      )
      .addCase(companyEntityTransactions.rejected, (state) => {
        state.entityTradesData = null;
      })

      .addCase(companyEntityList.pending, (state) => {
        state.entityList = [];
        state.entityListLoading = true;
      })
      .addCase(
        companyEntityList.fulfilled,
        (state, action: PayloadAction<CompanyEntityListResponse>) => {
          state.entityList = action.payload.data;
          state.entityListLoading = false;
        },
      )
      .addCase(companyEntityList.rejected, (state) => {
        state.entityList = [];
        state.entityListLoading = false;
      });
  },
});

export default CompanyEntitySlice.reducer;
